import { render } from "./NieuwsView.vue?vue&type=template&id=fe01db0e&scoped=true"
import script from "./NieuwsView.vue?vue&type=script&lang=js"
export * from "./NieuwsView.vue?vue&type=script&lang=js"

import "./NieuwsView.vue?vue&type=style&index=0&id=fe01db0e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe01db0e"]])

export default __exports__